import { Component, ElementRef, ViewChild, computed, inject, signal, } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "../../services/app.layout.service";
import { AuthService } from '../../../../core/services/auth.service';
import { DASHBOARD_HOME } from '../../../constants/url';
import { UserInfoStore } from '../../../../store/userInfo.store';
import { UserService } from '../../../../features/user/services/user.service';
import { LanguageService } from '../../../../core/services/language.service';


@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
})
export class AppTopBarComponent {

    homeUrl: string = DASHBOARD_HOME;

    items!: MenuItem[] | undefined;

    userInfoStore = inject(UserInfoStore);

    languageService = inject(LanguageService);

    langItems = computed<MenuItem[]>(() =>
        this.languageService.SUPPORTED.map((l) => ({
            label: `${l.flag}  ${l.label}`,
            command: () => this.languageService.setLanguage(l.code),
        }))
    );

    currentFlag = computed(
        () =>
            this.languageService.SUPPORTED.find((l) => l.code === this.languageService.current())?.flag ?? '🌐'
    );

    avatar = computed(() => {
        return `assets/avatars/${this.userInfoStore.profile().avatar}.png`
    })

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        public auth: AuthService,
        public userService: UserService
    ) {
        this.userInfoStore.getUserInfo();
    }

    ngOnInit() {
        this.items = [
            {
                separator: true
            },{
                label: 'Profile',
                items: [
                    {
                        label: 'Notifications',
                        icon: 'pi pi-bell',
                    },
                    {
                        label: 'Logout',
                        icon: 'pi pi-sign-out',
                        command: () => this.onLogout()
                    }
                ]
            },
        ];
    }

    switchTheme() {
        this.layoutService.toggleTheme();
    }

    onLogout() {
        this.auth.logout();
        this.userInfoStore.resetUserInfoState();
    }
}
